function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 6.53944C14 6.22362 13.8742 5.91708 13.6675 5.69415L12.9936 4.99747C12.7779 4.78383 12.4814 4.65378 12.1759 4.65378C11.8703 4.65378 11.5738 4.78383 11.3671 4.99747L8.72529 7.72844V1.18899C8.72529 0.538761 8.20411 0 7.5751 0H6.4249C5.79589 0 5.27471 0.538761 5.27471 1.18899V7.72844L2.63286 4.99747C2.42619 4.78383 2.12965 4.65378 1.82413 4.65378C1.51861 4.65378 1.22208 4.78383 1.00642 4.99747L0.341463 5.69415C0.125802 5.91708 0 6.22362 0 6.53944C0 6.85527 0.125802 7.16181 0.341463 7.37545L6.19127 13.4319C6.39795 13.6455 6.69448 13.7756 7 13.7756C7.30552 13.7756 7.60205 13.6455 7.81772 13.4319L13.6675 7.37545C13.8742 7.16181 14 6.85527 14 6.53944Z",
  fill: "#BBD422"
});

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.6d7e4a74.svg";
export { ForwardRef as ReactComponent };